import { render, staticRenderFns } from "./PrintSettingsDialog.vue?vue&type=template&id=18048a73&scoped=true"
import script from "./PrintSettingsDialog.vue?vue&type=script&lang=js"
export * from "./PrintSettingsDialog.vue?vue&type=script&lang=js"
import style0 from "./PrintSettingsDialog.vue?vue&type=style&index=0&id=18048a73&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18048a73",
  null
  
)

export default component.exports